<template>
  <TableList
    v-rect-loading="loading"
    class="audit-log-management-list"
    row-key="id"
    :title="$t(`${i18nPrefix}.title.auditLogManagement`)"
    :listData="listData"
    :tableColumns="tableColumns"
    :noAction="true"
    :showCreateBtn="false"
    :pagination="pagination"
    @pagination-change="handlePaginationChange"
  >
    <template #filter>
      <div class="filter-group">
        <el-select
          v-model="filter.type"
          clearable
          class="filter-select"
          @change="fetchAuditLogList"
        >
          <el-option
            v-for="(item, index) in logTypeOptionList"
            :key="index"
            :value="item.value"
            :label="item.label"
          ></el-option>
        </el-select>
        <el-select
          v-model="filter.operation"
          class="filter-select"
          clearable
          :placeholder="$t(`${i18nPrefix}.placeholder.operation`)"
          @change="searchAuditLogList"
        >
          <el-option
            v-for="(item, index) in operationOptionList"
            :key="index"
            :value="item.value"
            :label="item.label"
          ></el-option>
        </el-select>
      </div>
    </template>
  </TableList>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import { getI18nPropertyValue, createI18nProperty } from '@/i18n'
import TableList from '@/components/tableList/allowDragSortTable.vue'
import { LOG_TYPE, USER_MANAGEMENT_AUDIT_OPTIONS, ROLE_MANAGEMENT_AUDIT_OPTIONS } from '@/constant/company'

export default {
  components: {
    TableList
  },
  data () {
    return {
      i18nPrefix: 'admin.company.auditLogManagement',
      loading: false,
      listData: [],
      filter: {
        type: LOG_TYPE.USER_MANAGEMENT,
        operation: null
      },
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  computed: {
    logTypeOptionList () {
      return _.map(LOG_TYPE, (val, key) => createI18nProperty({ value: val }, 'label', `${this.i18nPrefix}.logType.${key}`))
    },
    operationOptionList () {
      let operationOptionList = null
      if (this.filter.type === LOG_TYPE.USER_MANAGEMENT) {
        operationOptionList = USER_MANAGEMENT_AUDIT_OPTIONS
      } else {
        operationOptionList = ROLE_MANAGEMENT_AUDIT_OPTIONS
      }
      return _.map(operationOptionList, (val, key) => createI18nProperty({ value: val }, 'label', `${this.i18nPrefix}.operation.${val}`))
    },
    tableColumns () {
      const columns = [
        {
          dataKey: 'company',
          label: this.$t(`${this.i18nPrefix}.label.companyName`),
          formatter: (data) => getI18nPropertyValue(data, 'name_cn', 'name_en')
        },
        {
          dataKey: 'operation',
          label: this.$t(`${this.i18nPrefix}.label.operation`),
          formatter: (data) => getI18nPropertyValue(data, 'cn', 'en')
        },
        {
          dataKey: 'detail',
          label: this.$t(`${this.i18nPrefix}.label.detail`),
          formatter: (data) => getI18nPropertyValue(data, 'cn', 'en')
        },
        {
          dataKey: 'operator',
          label: this.$t(`${this.i18nPrefix}.label.operator`),
          formatter: (data) => data.name
        },
        {
          dataKey: 'operation_time',
          label: this.$t(`${this.i18nPrefix}.label.operateTime`)
        }
      ]
      return columns
    }
  },
  created () {
    this.initAuditLogList()
  },
  methods: {
    ...mapActions('auditLog', ['getAuditLogList']),
    async initAuditLogList (reload) {
      if (reload) {
        this.pagination.page = 1
        this.pagination.total = 0
      }
      this.loading = true
      try {
        const resp = await this.getAuditLogList({
          type: this.filter.type || LOG_TYPE.USER_MANAGEMENT,
          operation: this.filter.operation,
          page: this.pagination.page,
          page_size: this.pagination.pageSize
        })
        if (resp) {
          this.listData = resp.log_list
          this.pagination.total = resp.total_count
        }
      } finally {
        this.loading = false
      }
    },
    fetchAuditLogList () {
      this.filter.operation = null
      this.initAuditLogList(true)
    },
    searchAuditLogList () {
      this.initAuditLogList(true)
    },
    handlePaginationChange () {
      this.initAuditLogList()
    }
  }
}
</script>

<style lang="scss" scoped>
.audit-log-management-list {

  .filter-group {
    display: flex;

    .filter-select {
      margin-right: 10px;
    }
  }

}
</style>
